import storage from 'redux-persist/es/storage';
import { createNoopStorage } from './storage/persist/noopStorage';

/** Получаем storage для браузера или noopStorage для сервера */
export const getStorage = () => {
    if (typeof window !== 'undefined') {
        return storage;
    }

    return createNoopStorage();
};